import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../content/images/user.png"; // with import
import $ from "jquery";
import { msalAuth } from "../../api/msal/MsalAuthProvider";
import HelpJson from "./config/help.json";
import preval from "preval.macro";
import moment from "moment";

const buildTimestamp = preval`module.exports = new Date().getTime();`;

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      isLoading: true,
      error: null,
    };
    this.helpOnclick = this.helpOnclick.bind(this);
  }

  showSpinner = () => {
    $("#cover-spin").show(0);
  };
  getDateString = () => {
    const lastUpdateMoment = moment.unix(buildTimestamp / 1000);
    const formattedDate = lastUpdateMoment.format("DD.MM.YYYY");

    return formattedDate;
  };
  async componentDidMount() {
    try {
      const accessTokenRequest = {
        scopes: ["user.read"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth.acquireTokenSilent(accessTokenRequest);
      } catch (error) {
        console.log("AquireTokenSilent failure");
        accessToken = await msalAuth.acquireTokenPopup(accessTokenRequest);
      }

      if (accessToken) {
        var user = await msalAuth.getAccount();
        this.setState({
          user: user,
          isLoading: false,
          error: null,
        });
      } else {
        this.setState({
          user: null,
          isLoading: false,
          error: "No access token...",
        });
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }

      this.setState({
        user: {},
        isLoading: false,
        error: error,
      });
    }
  }
  // help sayfasına tıklandığı zaman
  // hangi component'te ise o sayfanın help'ine gitmesini sağlıyor.
  helpOnclick() {
    let path = `/${window.location.href.split("/")[3]}/${
      window.location.href.split("/")[4]
    }`;

    HelpJson.forEach(function (item) {
      if (item.name == path) {
        window.open(item.url, "_blank");
      }
    });
  }

  render() {
    return (
      <div className="clearfix" name="header">
        <p
          style={{
            position: "absolute",
            width: "300px",
            padding: "3px",
            right: "-125px",
            top: "1px",
          }}
        >
          release date: {this.getDateString()}
        </p>
        <div className="float-left w-30">
          <NavLink
            id="management-maintenance"
            to={{ pathname: "/" }}
            className="float-left logo"
            onClick={this.showSpinner}
          ></NavLink>
        </div>
        <div className="float-left mt-4 ml-menu-25">
          <nav className="navbar navbar-expand-lg navbar-light ">
            <div className="mx-auto d-sm-flex d-block flex-sm-nowrap">
              <div className="text-white d-lg-none">MENÜ</div>
              <button
                className="navbar-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="fas fa-bars text-white" />
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav menu-line">
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      activeClassName="nav-link active-menu"
                      to={{
                        pathname: "/management-maintenance",
                      }}
                      onClick={this.showSpinner}
                    >
                      Beheer &amp; onderhoud{" "}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      activeClassName="nav-link active-menu"
                      to={{
                        pathname: "/catalog",
                        // componentName: "management-units",
                        isDidUpdate: "0038",
                      }}
                      onClick={this.showSpinner}
                    >
                      Catalogus
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to={{
                        pathname: "/report",
                        aboutProps: {
                          name: true,
                        },
                      }}
                      style={{ pointerEvents: "none" }}
                    >
                      Rapportage
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      activeClassName="nav-link active-menu"
                      to={{
                        pathname: "/settings",
                        // componentName: "management-units",
                        isDidUpdate: "0038",
                      }}
                      onClick={this.showSpinner}
                    >
                      Instellingen
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      style={{ cursor: "pointer" }}
                      onClick={this.helpOnclick}
                    >
                      Help
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
        <div className="float-right mt-4">
          <div className="userdropdown">
            <div className="userdropbtn clearfix">
              <div className="float-right userimage">
                <img src={logo} className="img-fluid" />
              </div>
              <div className="float-right">
                <div className="user-name ubuntubold">
                  {this.state.user.name}
                </div>
              </div>
              <div className="float-right mr-2">
                <span className="arrow-btn" />
              </div>
            </div>
            <div className="userdropdown-content ubuntumedium">
              <a href="#">
                <span className="icon-profile icon-dropdowncontent" />
                Profiel
              </a>
              <a href={
                "https://" +
                process.env.REACT_APP_BASE_URL_OMNIMAP +
                  "/" +
                  process.env.REACT_APP_TENANT_IDENTIFICATION +
                  "/login"
              } target={"_blank"}>
                <span className="icon-advanced icon-dropdowncontent" />
                Geavanceerd
              </a>
              <a href="/" onClick={(e)=> {
                // localStorage.setItem("isLogin", "false");
                //
                // msalAuth.logout();

                this.props.onSignOut(e)
              }
              }>
                <span className="icon-logout icon-dropdowncontent" />
                Uitloggen
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
